import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePopup } from '../hooks/popup/usePopup';
import { useCheckUserLoggedIn } from '../hooks/user/useCheckUserLoggedIn';

interface LoggedInUserOnlyProps {
  children: React.ReactNode;
}

export const LoggedInUserOnly = ({ children }: LoggedInUserOnlyProps) => {
  const Popup = usePopup();
  const location = useLocation();
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  useEffect(() => {
    if (!isUserLoggedIn) {
      Popup.toast('해당 기능을 이용하기 위해 로그인을 해주세요');
    }
  }, [isUserLoggedIn]);

  if (isUserLoggedIn) {
    return <>{children}</>;
  }

  return <Navigate to={'/oauth/login'} />;
};
